import { render, staticRenderFns } from "./WeHaveMoved.vue?vue&type=template&id=76dec9ae&scoped=true"
import script from "./WeHaveMoved.vue?vue&type=script&lang=js"
export * from "./WeHaveMoved.vue?vue&type=script&lang=js"
import style0 from "./WeHaveMoved.vue?vue&type=style&index=0&id=76dec9ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dec9ae",
  null
  
)

export default component.exports